// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Page4 from './components/Page4';
import Page3 from './components/Page3';
import Page2 from './components/Page2';
import Page5 from './components/Page5';
import Page6 from './components/Page6';
import Page7 from './components/Page7';
import Page8 from './components/Page8';
import Page9 from './components/Page9';
import Page10 from './components/Page10';
import Page11 from './components/Page11';
import Page12 from './components/Page12';
import Page13 from './components/Page13';
import Page14 from './components/Page14';
import Page15 from './components/Page15';
import Page16 from './components/Page16';
import CV from './components/CV';
import Login from './components/Login';

function App() {

  const [isLoggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const storedLoginStatus = localStorage.getItem('isLoggedIn');
    if (storedLoginStatus) {
      setLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    setLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
  };

return (
  <Router>
    {isLoggedIn && <Navbar onLogout={handleLogout} />} 
    <Routes>
      {/* Upload page has its own auth — accessible without dashboard login */}
      <Route path="/upload" element={<Page14 />} />
      {isLoggedIn ? (
	<>
        <Route path="/" element={<Page2 />} />
	    <Route path="/sahko" element={<Page3 />} />
	    <Route path="/cast" element={<Page4 />} />
        <Route path="/lights" element={<Page5 />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/fh" element={<Page6 />} />
        <Route path="/test" element={<Page7 />} />  
        <Route path="/chat" element={<Page8 />} />
        <Route path="/audio" element={<Page9 />} />
        <Route path="/location" element={<Page10 />} />
        <Route path="/archive" element={<Page11 />} />
        <Route path="/esp32" element={<Page12 />} />
        <Route path="/radar" element={<Page13 />} />
        <Route path="/cogni" element={<Page15 />} />
        <Route path="/lumen" element={<Page16 />} />
	</>
      ) : (
        <Route path="/*" element={<Login onLogin={handleLogin} />} />
      )}
    </Routes>
  </Router>
);
}

export default App;

